addEventListener("load", (event) => {});

const SELECTED_TAGS_QUERY_PARAMETER = 'selectedTags'
const UNUSED_CLASS = 'unused'
const SELECTED_CLASS = 'selected'

// const MAIN_PATTERN_CLASS = "div.pattern"
const MAIN_PATTERN_CLASS = "div.flex-pattern"

const urlParams = new URLSearchParams(window.location.search);
const selectedTags = (urlParams.get(SELECTED_TAGS_QUERY_PARAMETER)||"").split(",").filter(t => t !== "");

const processTags = () => {
    const showAll = selectedTags.length == 0
    document.querySelectorAll(`${MAIN_PATTERN_CLASS}`).forEach(p => {
        const patternTagIds = p.dataset.tagids.split(",").filter(t => t !== "")
        const visible = showAll || selectedTags.every(t => patternTagIds.includes(t))

        if (visible == false) {
            p.classList.add("hidden")
        } else {
            p.classList.add("visible")
        }
    })

    const tagsRelevantWithCurrentSelection = [...new Set(Array.from(document.querySelectorAll(`${MAIN_PATTERN_CLASS}.visible .tags ul li span`).values()).map(n => n.dataset.tagid))]

    document.querySelectorAll("button.tag").forEach(b => {
        if (selectedTags.includes(b.id)) {
            b.classList.add(SELECTED_CLASS)
        } else if (!tagsRelevantWithCurrentSelection.includes(b.id)) {
            b.classList.add(UNUSED_CLASS)
        }
    })
}

const handleTagButtonClick = (event) => {
    const tagId = event.target.id
    console.log("BUTTON", Array.from(event.target.classList.values()))
    if (Array.from(event.target.classList.values()).includes(UNUSED_CLASS)) {
        //  NOOP
    } else {
        var searchParams = new URLSearchParams(window.location.search);
        if (selectedTags.includes(tagId)) {
            searchParams.set(SELECTED_TAGS_QUERY_PARAMETER, selectedTags.filter(t => t != tagId))
        } else {
            searchParams.set(SELECTED_TAGS_QUERY_PARAMETER, selectedTags.concat(tagId))
        }

        // window.location.hash = 'patterns'
        window.location.search = searchParams.toString();
    }
    

}

onload = (event) => {
    const tagButtons = document.querySelectorAll("button.tag")
    tagButtons.forEach(b => {
        b.addEventListener('click', handleTagButtonClick)
    })

    processTags()
}



// WEBPACK FOOTER //
// /opt/build/repo/assets/js/pattern.js